import { initApiClient } from "tm-shared/api";

import { OPEN_REPLAY_IGNORED_ERROR_METHODS } from "@/constants";
import {
    ACCESS_INTERVAL,
    ACCESS_TOKEN,
    REFRESH_INTERVAL,
    REFRESH_TOKEN,
    TOKEN_EXPIRY_KEY,
} from "@/constants/config/auth";
import { logoutService } from "@/Services/Logout";
import { openReplayService } from "@/Services/OpenReplay";

export const setupApiClient = (): void => {
    initApiClient({
        appName: "tm",
        baseURL: import.meta.env.VITE_API_URL,
        apiHubToken: import.meta.env.VITE_JSON_RPC_TOKEN,
        getAccessToken: () => localStorage.getItem(ACCESS_TOKEN) || "",
        getRefreshToken: () => localStorage.getItem(REFRESH_TOKEN) || "",
        onTokensReceived: (tokens) => {
            localStorage.setItem(ACCESS_TOKEN, tokens.accessToken);
            localStorage.setItem(REFRESH_TOKEN, tokens.refreshToken);
            localStorage.setItem(
                ACCESS_INTERVAL,
                String(tokens.accessInterval),
            );
            localStorage.setItem(
                REFRESH_INTERVAL,
                String(tokens.refreshInterval),
            );
            localStorage.setItem(TOKEN_EXPIRY_KEY, Date.now().toString());
        },
        onAuthFailed: () => logoutService(),
        offlineThreshold: 3,
        onConnectionLost: () => {
            window.dispatchEvent(new Event("force-offline"));
        },
        onRequestError: ({ method, error: { code, message } }) => {
            if (!OPEN_REPLAY_IGNORED_ERROR_METHODS?.[method]?.includes?.(code))
                openReplayService.startOnError("bad_request", {
                    method,
                    message,
                    code,
                });
        },
    });
};
